import {
  Badge,
  Col,
  DatePicker,
  Image,
  Input,
  notification,
  Pagination,
  Row,
  Spin,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { TbFileExport } from "react-icons/tb";
import { LoadingOutlined } from "@ant-design/icons";
import { GetReportApi } from "../../../../Services/GeoTag";
import { AiFillEye } from "react-icons/ai";
import profileImg from "../../../../Assets/Images/profile-image.png";
import {
  checkPleaseLogin,
  download,
} from "../../../../Services/GeneralFunctions";
import "./Report.css";
import { useNavigate } from "react-router-dom";

const { Search } = Input;
const { RangePicker } = DatePicker;

export default function Report() {
  const [api, contextHolder] = notification.useNotification();

  const filterFlag = useRef(false);

  const navigate = useNavigate();

  const [reportData, setReportData] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);

  const [employeeIdFilter, setEmployeeIdFilter] = useState("");
  const [dateFilter, setDateFilter] = useState(["", ""]);

  const [tableLoader, setTableLoader] = useState(false);

  const GetReport = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    console.log("api call");
    setReportData(null);

    try {
      setTableLoader(true);
      const data = await GetReportApi(page, "", ["", ""], false);
      setTableLoader(false);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        setReportData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
      } else {
        api.error({
          message: "Error while fetching Report",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const GetFilteredReport = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    console.log("api call");

    setReportData(null);
    try {
      setTableLoader(true);
      const data = await GetReportApi(
        page,
        employeeIdFilter,
        dateFilter,
        false
      );
      setTableLoader(false);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        setReportData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
      } else {
        api.error({
          message: "Error while fetching Report",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const handleExport = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    try {
      const data = await GetReportApi(page, employeeIdFilter, dateFilter, true);

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data?.data?.success === false) {
        api.error({
          message: data?.data?.message,
          placement: "top",
        });
      } else {
        api.success({
          message: "Report Downloaded Successfully",
          placement: "top",
        });
        download(
          new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
          }),
          "Report.csv"
        );
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const onSearch = () => {
    filterFlag.current = true;
    if (page !== 1) {
      setPage(1);
    } else {
      GetFilteredReport();
    }
  };

  useEffect(() => {
    if (employeeIdFilter === "" && dateFilter === ["", ""]) {
      filterFlag.current = false;
    }
    if (filterFlag.current) {
      GetFilteredReport();
    } else {
      GetReport();
    }
  }, [page]);

  return (
    <>
      {contextHolder}

      <section className="bg-white p-3 shadow-sm border border-gray-200 w-full rounded-2xl flex justify-between mb-2">
        <h2 className="text-2xl font-semibold text-gray-800">Report</h2>
        <Col xxl={12} xl={14} lg={14} xs={24}>
          <Row>
            <Col className="p-1" sm={10} xs={24}>
              <RangePicker
                id="filterDate"
                style={{ width: " 100%" }}
                popupClassName="responsive-range-picker"
                onChange={(temp, date) => setDateFilter(date)}
              />
            </Col>
            <Col className="p-1" sm={10} xs={24}>
              <Search
                id="filterId"
                value={employeeIdFilter}
                onChange={(e) => setEmployeeIdFilter(e.target.value)}
                onSearch={onSearch}
                className="responsive-search"
                placeholder="Search Employee ID"
              />
            </Col>
            <Col className="p-1" sm={4} xs={24}>
              <div
                className="action-button bg-dark bs-opacity-75 bg-gradient text-center"
                style={{ width: "100%" }}
                onClick={handleExport}
              >
                <TbFileExport className="fs-5 fw-bold mx-1" />
                <span className="fw-bold">Export</span>
              </div>
            </Col>
          </Row>
        </Col>
      </section>
      <section className="bg-white p-4 pt-2 shadow-md border border-gray-900 w-full rounded-2xl mb-2">
        <Col
          style={{
            overflow: "auto",
          }}
        >
          <table className="custom-table mt-2">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email ID</th>
                <th>Employee ID</th>
                <th>Address</th>
                <th>Is Synced</th>
                <th>Attendence</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {reportData &&
                !tableLoader &&
                reportData.map((val) => (
                  <tr>
                    <td>{val.name}</td>
                    <td>{val.email}</td>
                    <td>{val.employee_id}</td>
                    <td
                      style={{
                        maxWidth: "300px",
                        minWidth: "200px",
                        whiteSpace: "break-spaces",
                      }}
                    >
                      {val.address}
                    </td>
                    <td>
                      {val.is_synced ? (
                        <Badge status="success" text="Yes" />
                      ) : (
                        <Badge status="error" text="No" />
                      )}
                    </td>
                    <td>{val.attendence_time}</td>
                    <td>
                      <Row className="justify-content-center">
                        <div
                          className="action-button mx-2 bg-light bg-gradient"
                          onClick={() => {
                            setImageUrl(val.image);
                            setShowImage(true);
                          }}
                        >
                          <AiFillEye className="text-dark fs-5" />
                        </div>
                      </Row>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot></tfoot>
          </table>
          {tableLoader && (
            <Row className="justify-content-center py-3">
              <Spin
                size="large"
                indicator={<LoadingOutlined className="text-light" />}
                spinning={true}
              />
            </Row>
          )}
        </Col>

        {total > 10 && (
          <div className="round-edges bg-light py-2 my-2 text-center">
            <Pagination
              current={page}
              showSizeChanger={false}
              onChange={(val, pageSize) => {
                setPage(val);
              }}
              total={total}
              hideOnSinglePage
            />
          </div>
        )}
      </section>

      <Image
        width={200}
        rootClassName="position-absolute"
        cl
        style={{ display: "none" }}
        src={imageUrl}
        fallback={profileImg}
        onError={() => console.log("error")}
        preview={{
          visible: showImage,
          scaleStep: 0.2,
          onVisibleChange: (value) => {
            setShowImage(value);
          },
        }}
      />
    </>
  );
}
